import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=5fa709f9&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"
import style0 from "./Rule.vue?vue&type=style&index=0&id=5fa709f9&prod&lang=scss&scoped=true"
import style1 from "./Rule.vue?vue&type=style&index=1&id=5fa709f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa709f9",
  null
  
)

export default component.exports